import React from 'react';
import styled from 'styled-components';
import { colors, fonts, breakpoints, containerStyle } from './designSystem';

// ---------------------------------------------------------------------------
// Styled Components
// ---------------------------------------------------------------------------

const BreadcrumbSection = styled.nav`
  background-color: ${colors.bleuPastel};
  padding: 14px 0;
`;

const Container = styled.div`
  ${containerStyle}
`;

const BreadcrumbList = styled.ol`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
  font-family: ${fonts.body};
  font-size: 0.85rem;
  gap: 4px;
  align-items: center;
`;

const BreadcrumbItem = styled.li`
  display: inline-flex;
  align-items: center;
  color: ${colors.textSecondary};

  &:last-child {
    color: ${colors.textDark};
    font-weight: 600;
  }
`;

const Separator = styled.span`
  margin: 0 6px;
  color: ${colors.textSecondary};
  opacity: 0.5;
`;

const BreadcrumbLink = styled.a`
  color: ${colors.bleu};
  text-decoration: none;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
    text-decoration: underline;
  }
`;

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export default function VilleBreadcrumb({ name }) {
  const crumbs = [
    { label: 'Accueil', href: '/' },
    { label: 'Annuaire', href: '/annuaire-velo' },
    { label: name || '', href: null },
  ];

  return (
    <BreadcrumbSection aria-label="Fil d'Ariane">
      <Container>
        <BreadcrumbList>
          {crumbs.map((crumb, i) => (
            <BreadcrumbItem key={i}>
              {i > 0 && <Separator>/</Separator>}
              {crumb.href ? (
                <BreadcrumbLink href={crumb.href}>{crumb.label}</BreadcrumbLink>
              ) : (
                <span>{crumb.label}</span>
              )}
            </BreadcrumbItem>
          ))}
        </BreadcrumbList>
      </Container>
    </BreadcrumbSection>
  );
}
